module.exports = require("aurelia-cookie");